<form class="form" *ngIf="articleModel">
    <div class="input-group">
        <label>Description (Max 155 char)</label>
        <textarea rows="15" name="seoDescription" [(ngModel)]="articleModel.seoDescription" maxlength="155">

        </textarea>
    </div>
</form>